var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.$root.unusedChartF2FList),function(chart,index){return _c('el-row',{key:index},[_c('div',{on:{"click":function($event){return _vm.OnRemove(chart.name)}}},[_c('el-card',{attrs:{"shadow":"always"}},[_vm._v(" "+_vm._s(chart.displayName)+" ")])],1)])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }